import React from 'react';
import { getLabel } from '../../data/labels';
import { ReactComponent as RouletteIcon } from '../../assets/roulette.svg';
import useOpenRoulette from './useOpenRoulette';

export default function RouletteButtonScroller(props) {
    const openRoulette = useOpenRoulette(props.conf);

    if (openRoulette == null) {
        return null;
    }

    return (
        <>
            <div className="xs_rouletteButton relative h-sports-navbar-height min-w-sports-navbar-height mx-1 shrink-0 flex flex-col items-center justify-center" onClick={openRoulette}>
                <div className="min-w-[60px] grid grid-cols-12 grid-rows-12 max-h-full leading-none items-center justify-items-center">
                    <div className="xs-sport-icon col-start-1 col-end-13 row-start-1 row-end-10 inline-block h-[24px] w-[24px]">
                        <RouletteIcon />
                    </div>
                    <div className="col-start-1 col-end-13 row-start-10 row-end-13 font-bold text-xxs text-cs1 uppercase truncate">{getLabel('roulette.title', 'Live Roulette')}</div>
                </div>
            </div>
        </>
    );
}